import React from 'react'
import { X, CheckCircle, XCircle, AlertTriangle, Info } from 'lucide-react'
import { clsx } from 'clsx'
import { ToastMessage } from '@/contexts/ToastContext'

interface ToastProps extends ToastMessage {
  onClose: () => void
}

const toastIcons = {
  success: CheckCircle,
  error: XCircle,
  warning: AlertTriangle,
  info: Info,
}

const toastStyles = {
  success: 'bg-green-50 border-green-200 text-green-800',
  error: 'bg-red-50 border-red-200 text-red-800',
  warning: 'bg-yellow-50 border-yellow-200 text-yellow-800',
  info: 'bg-accent-50 border-accent-200 text-accent-800',
}

export const Toast: React.FC<ToastProps> = ({ 
  type, 
  message, 
  description, 
  onClose 
}) => {
  const Icon = toastIcons[type]

  return (
    <div className={clsx(
      'flex items-start p-4 border rounded-lg shadow-lg min-w-80 max-w-md animate-slide-down',
      toastStyles[type]
    )}>
      <Icon className="w-5 h-5 mt-0.5 mr-3 flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="font-medium text-sm">
          {message}
        </p>
        {description && (
          <p className="mt-1 text-sm opacity-80">
            {description}
          </p>
        )}
      </div>
      <button
        onClick={onClose}
        className="ml-3 flex-shrink-0 opacity-60 hover:opacity-100 transition-opacity"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  )
}